
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/live-session/acts/[slug]",
      function () {
        return require("private-next-pages/live-session/acts/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/live-session/acts/[slug]"])
      });
    }
  